import React from "react";
import { useDispatch, useSelector } from "react-redux";

import './EditBranchForm.css';

import { branchDeleting, branchUpdating, changeEditBranchName, clearEditBranchForm, deleteBranch, editBranchFormIsActive, selectConfirmingBranchDelete, selectConfirmingBranchUpdate, selectEditBranchFormBranchId, selectEditBranchFormBranchName, setConfirmingBranchDelete, setConfirmingBranchUpdate, toggleEditBranchForm, updateBranch } from "./editBranchFormSlice";
import { removeBranch, updateBranchInfo } from "../manageBranches/branchesSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectToken } from "../login/loginSlice";

export default function EditBranchForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const activeEditForm = useSelector(editBranchFormIsActive);
    const editBranchFormBranchId = useSelector(selectEditBranchFormBranchId);
    const editBranchFormBranchName = useSelector(selectEditBranchFormBranchName);
    const confirmingUpdateBranch = useSelector(selectConfirmingBranchUpdate);
    const updatingBranch = useSelector(branchUpdating);
    const confirmingDeleteBranch = useSelector(selectConfirmingBranchDelete);
    const deletingBranch = useSelector(branchDeleting);

    const display = activeEditForm ? "flex" : "none";

    const handleEditBranchFormNameChange = (event) => {
        dispatch(changeEditBranchName(event.target.value));
    }
    
    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(toggleEditBranchForm());
        dispatch(clearEditBranchForm());
    }

    const handleConfirmCancelClick = () => {
        dispatch(setConfirmingBranchUpdate(false));
        dispatch(setConfirmingBranchDelete(false));
    }

    const handleDeleteButtonClick = (event) => {
        event.preventDefault();
        dispatch(setConfirmingBranchDelete(true));
    }

    const handleConfirmDeleteClick = () => {
        dispatch(deleteBranch({branchId: editBranchFormBranchId, token}));
        dispatch(toggleEditBranchForm());
        dispatch(removeBranch(editBranchFormBranchId));
        dispatch(setConfirmingBranchDelete(false));
    }

    const handleUpdateBranchButtonClick = (event) => {
        event.preventDefault();
        dispatch(setConfirmingBranchUpdate(true));
    }

    const handleConfirmUpdateClick = () => {
        const updatedBranch = {
            branchId: editBranchFormBranchId,
            branchName: editBranchFormBranchName
        }
        dispatch(updateBranch({branchToUpdate: updatedBranch, token}));
        dispatch(toggleEditBranchForm());
        dispatch(updateBranchInfo(updatedBranch));
        dispatch(setConfirmingBranchUpdate(false));
    }

    return (
        <form className="form" style={{display:display, flexDirection:'column'}}>
            <h3>Edit Branch</h3>
            <label>
                Branch Id: {editBranchFormBranchId}
            </label>
            <label htmlFor="branchName">
                Branch Name:
                <input value={editBranchFormBranchName} onChange={handleEditBranchFormNameChange}></input>
            </label>
            <div className="button-container">
                <button onClick={handleCancelButtonClick} disabled={updatingBranch || deletingBranch}>Cancel</button>
                <button onClick={handleDeleteButtonClick} disabled={updatingBranch || deletingBranch}>Delete Branch</button>
                <button onClick={handleUpdateBranchButtonClick} disabled={updatingBranch || deletingBranch}>Update Branch</button>
            </div>
            {confirmingDeleteBranch ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmDeleteClick}/> : ""}
            {confirmingUpdateBranch ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmUpdateClick}/> : ""}
        </form>
    )
}